import React from 'react';
import { Package, Tag } from 'lucide-react';
import { Tabs, TabItem } from '@components/Tabs';
import { usePermissions } from '@hooks/usePermissions';
import { ProductsTabView } from './ProductsTabView';
import { ProductCategoriesView } from './ProductCategoriesView';

/**
 * Página de Produtos (Suprimentos → Produtos) com abas:
 *  - "Produtos": listagem/CRUD de produtos e a sub-aba de nomes/dimensões.
 *  - "Categorias": CRUD de categorias de produto (visível para quem pode ver produtos).
 */
export const ProductsPage: React.FC = () => {
  const { checkPermission } = usePermissions();
  const canViewCategories = checkPermission('product_categories.read').hasPermission;

  const tabs: TabItem[] = [
    {
      id: 'products',
      label: 'Produtos',
      icon: <Package size={16} />,
      content: <ProductsTabView />,
    },
  ];

  if (canViewCategories) {
    tabs.push({
      id: 'categories',
      label: 'Categorias',
      icon: <Tag size={16} />,
      content: <ProductCategoriesView />,
    });
  }

  return <Tabs tabs={tabs} defaultTab="products" />;
};

export default ProductsPage;
